import { useAxios } from '@/hooks/useAxios';
import { defineStore } from 'pinia';

export const useMenuStore = defineStore('menu', {
    state: () => ({
        menuItems: [],
        openTabs: [],
        activeTab: null,
        error: null,
        maxTabs: 10
    }),
    getters: {
        getMenuItemsByParentCode: (state) => (parentCode) => {
            return state.menuItems.filter((item) => item.parent_code === parentCode).sort((a, b) => a.menu_item_order - b.menu_item_order);
        },
        getRootMenuItems: (state) => {
            return state.menuItems.filter((item) => item.menu_item_level === 1).sort((a, b) => a.menu_item_order - b.menu_item_order);
        }
    },
    actions: {
        async fetchMenuItems() {
            this.error = null;
            const url = `/api/authorization/menu`;
            const config = { method: 'get' };

            const extractPageItems = (items) => {
                let pageItems = [];
                for (const item of items) {
                    if (item.menu_item_type === 'page') {
                        pageItems.push({
                            path: item.menu_item_url,
                            name: item.menu_item_code,
                            meta: { title: item.menu_item_name },
                            component: () => loadComponent(item.menu_item_url)
                        });
                    }
                    if (item.children_menu_items && item.children_menu_items.length > 0) {
                        pageItems = pageItems.concat(extractPageItems(item.children_menu_items));
                    }
                }
                return pageItems;
            };

            const loadComponent = (path) => {
                if (path === '/') {
                    return import('@/views/Dashboard.vue');
                }
                const segments = path.split('/').filter(Boolean);
                if (segments.length === 2) {
                    return import(`@/views/pages/${segments[0]}/${segments[1]}.vue`);
                } else if (segments.length === 3) {
                    return import(`@/views/pages/${segments[0]}/${segments[1]}/${segments[2]}.vue`);
                }
                // 기본 경로
                return import(`@/views/pages${path}.vue`);
            };

            const { data, error, execute } = useAxios(url, config, {
                immediate: false,
                onSuccess: (response) => {
                    //response.data.data.pop(2); // 지우기
                    this.setMenuItems(response.data.data);
                },
                onError: (err) => {
                    console.error('Error Get MenuItems:', err.message);
                    this.error = err.message;
                }
            });

            await execute();
        },
        setMenuItems(items) {
            this.menuItems = items;
        },
        addTab(tab) {
            if (this.openTabs.length >= this.maxTabs) {
                // console.log('탭은 최대 12개까지 관리할 수 있습니다.');
                // return false;
                this.openTabs.shift();
            }

            if (!this.openTabs.some((t) => t.menu_item_code === tab.menu_item_code)) {
                this.openTabs.push(tab);
            }
            this.setActiveTab(tab.menu_item_code);
        },
        removeTab(menuItemCode) {
            const index = this.openTabs.findIndex((tab) => tab.menu_item_code === menuItemCode);
            if (index !== -1) {
                this.openTabs.splice(index, 1);
                if (this.activeTab === menuItemCode) {
                    this.setActiveTab(this.openTabs[Math.max(0, index - 1)]?.menu_item_code);
                }
            }
        },
        setActiveTab(menuItemCode) {
            this.activeTab = menuItemCode;
            const activeMenuItem = this.menuItems ? this.menuItems.find((item) => item.menu_item_code === menuItemCode) : [];
            if (activeMenuItem) {
                this.currentTitle = activeMenuItem.menu_item_name;
            }
        },
        getTabByCode(menuItemCode) {
            return this.openTabs.find((tab) => tab.menu_item_code === menuItemCode);
        },
        clearTabs() {
            this.openTabs = [];
            this.activeTab = null;
        }
    },
    persist: {
        enabled: true,
        strategies: [
            {
                key: 'menu',
                storage: localStorage,
                paths: ['openTabs', 'activeTab']
            }
        ]
    }
});
